export default __webpack_public_path__ + "static/media/ubuntu-regular.db912642.woff2";